import { render, staticRenderFns } from "./LeadSupply.vue?vue&type=template&id=242e4534&scoped=true"
import script from "./LeadSupply.vue?vue&type=script&lang=ts"
export * from "./LeadSupply.vue?vue&type=script&lang=ts"
import style0 from "./LeadSupply.vue?vue&type=style&index=0&id=242e4534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e4534",
  null
  
)

export default component.exports